module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00028-fs8.f8ef343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00028-fs8.png
// module id = 181
// module chunks = 0